import { enumOf, useTableParams, type FieldSpec } from "@/hooks/useTableParams";
import { ENUM_MS_COMAPNY_POLICIES_STATUS } from "@/utils/enums/company-policies.enum";

import type { IPolicyAcknowledgementFilters } from "@/types/(company)/company-policies.interface";

const DEFAULTS: IPolicyAcknowledgementFilters = {
  acknowledgedOnFrom: null,
  acknowledgedOnTo: null,
  viewedOnFrom: null,
  viewedOnTo: null,
  statusLabel: "",
};

/** URL-backed toolbar state for the policy acknowledgement table. */
export const usePolicyAcknowledgementParams = () =>
  useTableParams<IPolicyAcknowledgementFilters>({
    defaults: DEFAULTS,
    schema: {
      acknowledgedOnFrom: "dateObj",
      acknowledgedOnTo: "dateObj",
      viewedOnFrom: "dateObj",
      viewedOnTo: "dateObj",
      statusLabel: enumOf(Object.values(ENUM_MS_COMAPNY_POLICIES_STATUS)),
    } satisfies Partial<Record<keyof IPolicyAcknowledgementFilters, FieldSpec>>,
  });
